import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 135,
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  marginStyle: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  paperStyle: {
    width: 450,
    height: 70,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    padding: 15,
    borderBottom: '1px solid',
    borderBottomColor: '#e3e3e3',
  },
  sorter: {
    width: '100%',
    height: 28,
    borderBottom: '1px solid',
    borderBottomColor: '#e3e3e3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#969595',
  },
  button: {
    minWidth: 60,
    height: 40,
    fontSize: 20,
  },
  label: {
    textTransform: 'none',
  },
  textField: {},
  root: {
    width: 450,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nestedCountries: {
    paddingLeft: theme.spacing(10),
  },
  parentPaper: {
    position: 'absolute',
    marginTop: 0,
    zIndex: 300,
    maxHeight: 400,
    overflow: 'auto',
  },
  availabilityTextFieldParent: {
    minWidth: 150,
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginTop: 10,
    marginBottom: 10,
  },
  searchButtonPopover: {
    padding: '7px',
    transform: 'translate(-8px, -16px)!important',
    width: '320px',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  buttonApply: {
    height: '45px',
    textTransform: 'none',
  },
  checkbox: {
    marginLeft: 3,
  },
  formControlRightFilters: {
    margin: theme.spacing(1),
  },
  toTheRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '20px 0',
  },
  equipmentAppbar: {
    backgroundColor: theme.palette.constrastGreyNormal.main,
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.constrastGreyBlack.main,
  },
}));

export default styles;
